import React from 'react';
import { Award, Clock, Heart, Users } from 'lucide-react';

const About = () => {
  const highlights = [
    {
      icon: Heart,
      title: 'Local Favorite',
      description: 'Beloved by the Chapel Market community'
    },
    {
      icon: Award,
      title: 'Unbeatable Prices',
      description: 'Affordable meals under £10'
    },
    {
      icon: Clock,
      title: 'Fast Service',
      description: 'Ready in under 10 minutes'
    },
    {
      icon: Users,
      title: 'Family-Owned',
      description: 'Warm and friendly atmosphere'
    }
  ];

  return (
    <section className="py-20 bg-zinc-900 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-600/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-600/10 rounded-full blur-3xl" />
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Welcome to <span className="text-orange-500">N1 Grill</span>
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-8" />
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            A beloved Chapel Market grill serving delicious burgers, doner wraps, chicken wings 
            and fresh fries at unbeatable prices. Known for generous portions, fast service and 
            a warm, friendly atmosphere.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {highlights.map((item, index) => (
            <div 
              key={index}
              className="group bg-zinc-800/50 backdrop-blur-sm rounded-xl p-6 border border-zinc-700 hover:border-orange-500 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-lg hover:shadow-orange-500/20"
            >
              <div className="bg-gradient-to-br from-orange-500 to-red-600 w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <item.icon className="h-7 w-7 text-white" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{item.title}</h3>
              <p className="text-gray-400">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-orange-600/20 to-red-600/20 rounded-2xl p-6 border border-orange-500/30">
          <div className="grid md:grid-cols-2 gap-6 items-center">
            {/* Storefront Image */}
            <div className="relative h-64 md:h-80 overflow-hidden rounded-xl shadow-2xl shadow-black/50">
              <img 
                src="https://customer-assets.emergentagent.com/job_n1-grill-london/artifacts/0rzuccmk_image.png"
                alt="N1 Grill Storefront"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            
            {/* Text Content */}
            <div className="flex flex-col gap-6">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">Open Daily Until 23:30</h3>
                <p className="text-gray-300 text-lg">Dine-in • Takeaway • Delivery</p>
              </div>
              <div className="flex items-center gap-2">
                <div className="flex">
                  {[...Array(4)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-2xl">★</span>
                  ))}
                  <span className="text-gray-500 text-2xl">★</span>
                </div>
                <span className="text-white font-semibold text-lg">(231 reviews)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
